'use client';

import { Box, Typography } from '@mui/material';
import { sendGTMEvent } from '@next/third-parties/google';
import { usePathname } from 'next/navigation';
import FlagOutlinedIcon from '@mui/icons-material/FlagOutlined';

import { colorVariables } from '@/constants';
import BreadCrumbs from '@/page-components/Search/BreadCrumbs';
import { Vendor } from '@/lib/types/interfaces/Vendor';

interface Props {
  service: Vendor
}

const ReportSection = ({ service }: Props) => {
  const pathname = usePathname();
  const reportBody = `URL: ${pathname} Date: ${new Date().toLocaleString('en', {
    weekday: 'short',
    year: 'numeric',
    month: '2-digit',
    day: 'numeric',
  })}`;

  const handleReportClick = () => {
    sendGTMEvent({
      event: 'click_on_report',
      url: pathname,
      categories: service.categories.map(({ name }) => name)?.join() || '',
      subCategories: service.subcategories.map(({ name }) => name)?.join() || '',
    });
  };

  return (
    <>
      <Box
        paddingY={{ xs: 3 }}
        paddingX={{ xs: 3, lg: 18 }}
        display='flex'
        alignItems='center'
        borderTop={`1px solid ${colorVariables.separatorColor}`}
      >
        <FlagOutlinedIcon />
        <Typography marginX={1}>
          Is there information that looks off?
        </Typography>
        <a
          href={`mailto:report@propjump.com?subject=Report&body=${reportBody}`}
          target='_blank'
          rel='noreferrer'
          style={{ color: colorVariables.primaryColor }}
          onClick={handleReportClick}
        >
          Report
        </a>
      </Box>
      <Box
        borderTop={`1px solid ${colorVariables.separatorColor}`}
        paddingY={{ xs: 3 }}
        paddingX={{ xs: 3, lg: 18 }}
      >
        <BreadCrumbs service={service} />
      </Box>
    </>
  );
};

export default ReportSection;
